<template>
<div class="container-base"
     v-once>
  <div class="pages page-static">
    <div class="page-static-inner">
      <h1>入力した情報の保存</h1>
      <p>入力した情報はご利用の端末のブラウザ（SafariやChromeなど）の履歴に保存され、ブラウザを閉じても再度サイトにアクセスした際に続きを入力できるようになっています。</p>
      <p style="color:red;">共用パソコン(ネットカフェや学校など複数の人が利用するパソコン)などでご利用いただく場合、パソコン内に残ったデータを他の人に見られてしまう可能性があります。yagishでは、サービスをご利用いただいた後にデータを削除することを推奨しております。</p>
      <br>
      <div class="text-right">
        <el-button id="account-delete-account-dialog" type="success"
          @click="$router.push({name: 'accountDelete'});">ブラウザのデータを削除する</el-button>
      </div>
      <br>
      <p>また、「設定 ＞ データ・アカウントの削除画面を開く ＞ ブラウザのデータを削除する」からでもブラウザの履歴を削除できます。</p>
      <ul>
        <li>ブラウザの入力履歴はサーバーに保存されないため、その端末を使用している人しか見ることはできません。</li>
        <li>会員登録（Googleアカウントでログイン）を行うと、ブラウザの履歴とは別にサーバーへ情報の保存ができるようになります。他の端末に情報を引き継いだり、データを繰り返し使うときにおすすめです。</li>
      </ul>

      <div class="back-button">
        <router-link to="/">トップに戻る</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
